export const SET_TEAM = 'SET_TEAM'
export const SET_ID = 'SET_ID'
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
export const SET_TEAM_TREE = 'SET_TEAM_TREE'
export const SET_TEAM_AUTOCOMPLETE = 'SET_TEAM_AUTOCOMPLETE'
export const SET_SELECTED_ID = 'SET_SELECTED_ID'
export const SET_SELECTED_CONTACT_ID = 'SET_SELECTED_CONTACT_ID'
export const SET_SELECTED_TEAM_MEMBER_ID = 'SET_SELECTED_TEAM_MEMBER_ID'
export const SET_TEAM_MEMBER_IDS = 'SET_TEAM_MEMBER_IDS'
export const SET_TEAM_MEMBERS = 'SET_TEAM_MEMBERS'
export const SET_MEMBER_ID = 'SET_MEMBER_ID'
export const SET_SELECTED_MEMBER_PROFILE = 'SET_SELECTED_MEMBER_PROFILE'
export const SET_MEMBER_PROFILE = 'SET_MEMBER_PROFILE'
export const SET_MEMBER_PROFILE_ID = 'SET_MEMBER_PROFILE_ID'
export const SET_TEAM_MEMBER_ATTRIBUTES = 'SET_TEAM_MEMBER_ATTRIBUTES'
export const SET_TIME_ZONE_LIST = 'SET_TIME_ZONE_LIST'
export const SET_LANGUAGE_LIST = 'SET_LANGUAGE_LIST'
export const SET_MAKE_LIST = 'SET_MAKE_LIST'
export const SET_REGION_LIST = 'SET_REGION_LIST'
export const SET_SCAN_TYPE_CERTIFICATION_LIST = 'SET_SCAN_TYPE_CERTIFICATION_LIST'
export const SET_STATE_CERTIFICATION_LIST = 'SET_STATE_CERTIFICATION_LIST'
export const SET_MEMBER_ATTRIBUTE_OPTIONS = 'SET_MEMBER_ATTRIBUTE_OPTIONS'
export const SET_MEMBER_ATTRIBUTE_SELECTED_VALUES = 'SET_MEMBER_ATTRIBUTE_SELECTED_VALUES'
export const SET_MEMBER_ATTRIBUTE_SELECTED_VALUES_TO_EMPTY = 'SET_MEMBER_ATTRIBUTE_SELECTED_VALUES_TO_EMPTY'
export const SET_MEMBER_ATTRIBUTE_LABEL = 'SET_MEMBER_ATTRIBUTE_LABEL'
export const SET_PROFILE_TEAM_LEAD = 'SET_PROFILE_TEAM_LEAD'
export const SET_TEAM_LEAD = 'SET_TEAM_LEAD'
export const SET_TECHNICIANS = 'SET_TECHNICIANS'
export const SET_TEAM_NAME = 'SET_TEAM_NAME'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'

export const SESSION_PAGE_SIZE = 'adminTeams/pageSize'
export const SESSION_SEARCH_TERM = 'adminTeams/searchTerm'
// export const RESET_TEAM_MEMBERS = 'RESET_TEAM_MEMBERS'

export const SET_STATE_CERTIFICATION_ID = 'SET_STATE_CERTIFICATION_ID'
export const SET_STATE_CERTIFICATION_IDS_LIST = 'SET_STATE_CERTIFICATION_IDS_LIST'
export const SET_STATE_CERTIFICATION_ID_TXT_ISDISABLED = 'SET_STATE_CERTIFICATION_ID_TXT_ISDISABLED'



// WEBPACK FOOTER //
// ./src/store/modules/admin/teams/types.js